import { cn } from '@repo/lib/cn';
import { questionSingleChoiceSchema } from '@repo/schemas/quiz/questionSingleChoice';
import { CircleAlertIcon, PlusIcon } from 'lucide-react';

import { QuestionContentFormField, QuestionSingleAnswerField } from '@/components/features/quiz/question/question-builder';
import { Button } from '@/components/ui/button';
import { ErrorMessage, Form } from '@/components/ui/form';
import { useQuestionSingleForm } from '@/hooks/questions';
import { questionsLabel } from '@/lib/questions-labels';
import { formErrorToast } from '@/utils/form';

import type { QuestionSingleFormProps } from '.';

export function QuestionSingleForm(questionSingleFormProps: QuestionSingleFormProps) {
  const { data, onSubmit = () => {}, className, ...props } = questionSingleFormProps;
  const { form, singleQuestionAnswers, handleAddAnswer, toggleCorrect, handleRemoveAnswer } = useQuestionSingleForm(data);

  return (
    <Form {...form}>
      <form {...props} noValidate onSubmit={form.handleSubmit(onSubmit, () => formErrorToast(form, questionSingleChoiceSchema))} className={cn('h-full', className)}>
        <div className="divide-border-primary divide-y">
          <QuestionContentFormField />

          <div className="space-y-6 p-3">
            <div className="text-muted-foreground flex items-center gap-1 text-xs">
              <CircleAlertIcon className="size-4" />
              <p>{data?.type && questionsLabel[data.type].builderDesc}</p>
            </div>
            <ErrorMessage className="my-4 min-h-0 w-full" name={'answers.root'} />
            <div className="flex flex-col items-stretch gap-3 xl:flex-row">
              {singleQuestionAnswers.fields.map((field, index) => (
                <QuestionSingleAnswerField
                  key={field.id}
                  form={form}
                  index={index}
                  toggleCorrect={toggleCorrect}
                  removeAnswer={handleRemoveAnswer}
                  canRemove={singleQuestionAnswers.fields.length > 2}
                />
              ))}
              <Button
                type={'button'}
                variant={'outline'}
                size={'sm'}
                className={cn('border-dashed w-full xl:w-auto xl:my-auto', singleQuestionAnswers.fields.length === 5 && 'hidden')}
                onClick={handleAddAnswer}
              >
                <PlusIcon />
                <span className="block xl:hidden">Dodaj odpowiedź</span>
              </Button>
            </div>
          </div>
        </div>
      </form>
    </Form>
  );
}
